import { useEffect, useState } from "react";
import { getFbTokensApi, createFbTokenApi, updateFbTokenApi, deleteFbTokenApi, } from "../apiServices/fbTokenServices";

const useFbTokens = () => {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTokens = async () => {
    try {
      setLoading(true);

      const res = await getFbTokensApi();

      setTokens(res?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createToken = async (payload) => {
    await createFbTokenApi(payload);
    fetchTokens();
  };

  const updateToken = async (id, payload) => {
    await updateFbTokenApi(id, payload);
    fetchTokens();
  };

  const deleteToken = async (id) => {
    await deleteFbTokenApi(id);
    fetchTokens();
  };

  useEffect(() => {
    fetchTokens();
  }, []);

  return { tokens, loading, fetchTokens, createToken, updateToken, deleteToken, };
};

export default useFbTokens;
